<h2 mat-dialog-title translate="CALLS.ADMIN.MANAGE_CALL_USERS.TITLE"></h2>
<mat-dialog-content>
  <p class="call-name">{{ data.callName }}</p>
  <p translate="CALLS.ADMIN.MANAGE_CALL_USERS.DESCRIPTION"></p>

  @if (users.length > 0) {
    <ul class="call-users">
      @for (callUser of users; track callUser.userId) {
        <li>
          <div class="user">
            <div class="name">{{ callUser.firstName }} {{ callUser.lastName }}</div>
            <div class="email">{{ callUser.email }}</div>
          </div>
          <button
            mat-icon-button
            (click)="removeUser(callUser)"
            [matTooltip]="'CALLS.ADMIN.REVOKE_USER_ACCESS.BUTTON' | translate"
            [attr.aria-label]="'CALLS.ADMIN.REVOKE_USER_ACCESS.BUTTON' | translate"
          >
            <mat-icon>person_remove</mat-icon>
          </button>
        </li>
      }
    </ul>
  } @else {
    <p translate="CALLS.ADMIN.MANAGE_CALL_USERS.NO_USERS"></p>
  }

  @if (usersResult$ | async; as usersResult) {
    @if (usersResult.isLoading) {
      <app-spinner></app-spinner>
    } @else {
      <div class="add-user">
        <mat-form-field class="user-select" subscriptSizing="dynamic">
          <mat-label translate="CALLS.ADMIN.ADD_CALL_USER.SELECT_USER"></mat-label>
          <input
            type="text"
            matInput
            [matAutocomplete]="userAutocomplete"
            [(ngModel)]="filter"
            [placeholder]="'CALLS.ADMIN.ADD_CALL_USER.SEARCH_PLACEHOLDER' | translate"
          />
          <mat-autocomplete #userAutocomplete="matAutocomplete">
            @for (user of addableUsers; track user.id) {
              <mat-option [value]="describeUser(user)">{{ describeUser(user) }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button mat-flat-button color="primary" [disabled]="selectedUser === null" (click)="addUser()" translate="CALLS.ADMIN.ADD_CALL_USER.CONFIRM"></button>
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button mat-dialog-close translate="COMMON.CLOSE"></button>
</mat-dialog-actions>
